
import { useRemarkSync } from 'react-remark';
import styled from 'styled-components';

const MarkdownContainer = styled.div<{
	padding?: { top?: string; right?: string; bottom?: string; left?: string; },
}>`
	margin: ${({ padding }) => `${padding?.top ?? 0} ${padding?.right ?? 0} ${padding?.bottom ?? 0} ${padding?.left ?? 0}`};
	a {
		color: ${({ theme }) => theme.color.prune};
	}
	> ul > li {
		margin: 1rem 0;
	}
`;

const MarkdownParser = ({ children, padding }: { children: any, padding?: { top?: string; right?: string; bottom?: string; left?: string } }) => {

	const markdownContent = useRemarkSync(children);

	return (
		<MarkdownContainer padding={padding}>
			{markdownContent}
		</MarkdownContainer>
	);
};

export default MarkdownParser;
